module.exports = __webpack_public_path__ + "img/title5.9ff2fd9c.png";